import { CurriedPropsAdder, flowMax, addProps } from 'ad-hok'
import { addApi, addConfig } from 'shared/src/api'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import {
  ResourceName,
  ResourceType,
  makeResources,
} from '../components/resource'

type AddResourceWithName = <TProps extends {}>(
  resourceName: (props: TProps) => ResourceName
) => CurriedPropsAdder<TProps, { resource: ResourceType<any, any, any> }>

export const addResourceWithName: AddResourceWithName = (getResourceName) =>
  flowMax(
    addProps((props) => ({
      resourceName: getResourceName(props),
    })),
    addApi,
    addConfig,
    addTranslationHelpers,
    addProps(
      ({ resourceName, api, config, t }) => ({
        resource: makeResources(api, config, t)[resourceName as ResourceName],
      }),
      ['resourceName', 'api', 'config', 't']
    )
  )
